import styled from 'styled-components';

export const StyledAmount = styled.span<{ positive?: boolean }>`
  color: ${({ theme, positive }): string =>
    positive ? theme.palette_success_50 : theme.palette_gray_100};
`;
